var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m9.885 8.5 5.724-5.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L8 6.615 2.276.89a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L6.115 8.5.39 14.224a1.332 1.332 0 0 0 .943 2.276c.34 0 .682-.131.942-.391L8 10.385l5.724 5.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L9.885 8.5Z"
})));
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "assets/media/close-icon.c0e1967c1f7514a55bfb2ac19ed1fd85.svg";